import { useNavigate } from 'react-router-dom';
import '@assets/css/auth/loginWaitingApproval.css';

export default function LoginWaitingApproval() {
    const navigate = useNavigate();

    const handleBackToLogin = () => {
        // 쿠키 삭제
        document.cookie = 'ab_at=; Max-Age=0; Path=/;';
        document.cookie = 'ab_rt=; Max-Age=0; Path=/;';
        document.cookie = 'signup_token=; Max-Age=0; Path=/;';
        navigate('/login');
    };

    return (
        <div className="login-waiting-approval">
            <div className="waiting-container">
                <div className="waiting-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                </div>
                <h2>승인 대기 중</h2>
                <div className="waiting-message">
                    <p>회원가입 정보가 성공적으로 제출되었습니다.</p>
                    <p>관리자 승인 후 서비스를 이용하실 수 있습니다.</p>
                </div>
                <div className="waiting-info">
                    <p>승인이 완료되면 등록된 이메일로 안내 메일이 발송됩니다.</p>
                    <p>문의사항이 있으시면 관리자에게 연락해 주세요.</p>
                </div>
                <button onClick={handleBackToLogin} className="back-to-login-button">
                    로그인 페이지로 돌아가기
                </button>
            </div>
        </div>
    );
}